import { ISchema } from "@/interfaces/entities/schema_sensor"

export interface ISensorFormData {
    sensor_name: string
    mac_address: string
    subid: string
    manufacturer: string
    schema_sensor_id: number | null
    schema_name: string
    sensor_type: string
    is_public_schema: boolean
    schema: ISchema
}

export const initialFormData: ISensorFormData = {
    sensor_type: null,
    manufacturer: null,
    sensor_name: '',
    subid: '',
    mac_address: '',
    schema_sensor_id: null,
    schema_name: "",
    is_public_schema: false,
    schema: undefined
}